// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edpz2dPWky2Kh95WyIZI{flex-direction:column;justify-content:center;align-items:center;gap:48px;width:100%;height:100%;display:flex}.edpz2dPWky2Kh95WyIZI .z1ZCApgPX9EFo6igqBRN{flex-direction:column;align-items:center;gap:4px;display:flex}.edpz2dPWky2Kh95WyIZI .v2o1CyeBL5ggkBy_XyvM{text-align:center}.edpz2dPWky2Kh95WyIZI .uztcu0ZDXjs32Otb5h2S{width:120px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": `edpz2dPWky2Kh95WyIZI`,
	"block": `z1ZCApgPX9EFo6igqBRN`,
	"desc": `v2o1CyeBL5ggkBy_XyvM`,
	"action": `uztcu0ZDXjs32Otb5h2S`
};
export default ___CSS_LOADER_EXPORT___;
